import ldb from '../base/lib/ldb'
import { XHR } from '../base/lib/xhr'
import {emitter} from '../base/utils/emitter'

let popup: Window

export default {
    async googleLogin() {
        const W = Math.max(window.innerWidth, 600)
        const H = Math.max(window.innerHeight, 800)
        const { data } = await XHR.get('/auth/google', { type: 'text/html' })
        popup = <Window>window.open('', 'DaneshFX authentication', `status=1, height=${H}, width=${W}, toolbar=0, resizable=0`)
        popup.location.href = data
        return true
    },
    async emailLogin(data: { user: string, pass: string }) {
        const res = await XHR.post('/auth/email', data)
        try {
            if (res.token) {
                if (!res.roles.includes('admin')) {
                    emitter.emit('wrong-role', res)
                    return false
                }
                ldb.save(res.token).as('DANESH_FX_ADMIN_TOKEN')
                emitter.emit('loggedin', res)
            } else {
                emitter.emit('loggedin-failed', res)
            }

        } catch (error) {
            console.log(error)
        }
    },
    checkToken,
}

window.addEventListener('message', (event) => {
    if (!event.data || typeof event.data == 'object') {
        return;
    }

    if (event.origin !== window.origin) return
    popup.close()
    console.log('---', event.data);

    getProfile(event.data)
    return true
}, false)

async function getProfile(token: string) {
    console.log('---', token);

    const { data } = await XHR.get('/auth/google/callback?code=' + token)
    ldb.save(data.token).as('DANESH_FX_ADMIN_TOKEN')

    emitter.emit('loggedin', data)
}

async function checkToken() {
    const { data } = await XHR.get('/api/check', { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
    return data

}
